import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["counter", "input"]
  static values = { maxLength: Number }

  connect() {
    this.isBootstrapForm = this.inputTarget.parentElement.classList.contains("form-group")
    if (this.isBootstrapForm) {
      this.fieldHasError = this.inputTarget.parentElement.classList.contains("has-error")
    } else {
      this.fieldHasError = this.inputTarget.classList.contains("is-invalid")
    }
    this.count()
    this.inputTarget.addEventListener("input", this.count)
  }

  count() {
    const length = this.inputTarget.value.length
    const shouldHighlight = length > this.maxLengthValue
    this.counterTarget.innerText = `${length}/${this.maxLengthValue}`
    this.counterTarget.classList.toggle("text-danger-base", shouldHighlight)
    if (!this.fieldHasError) {
      if (this.isBootstrapForm) {
        this.inputTarget.parentElement.classList.toggle("has-error", shouldHighlight)
      } else {
        this.inputTarget.classList.toggle("is-invalid", shouldHighlight)
      }
    }
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.count)
  }

  initialize() {
    this.count = this.count.bind(this)
  }
}
